<div *ngIf="isAvailable" class="meeting-review-form" [class.mobile]="deviceService.isMobile()">
  <ng-template [ngIf]="!isRated" [ngIfElse]="showReview">
    <div class="meeting-info">
      <div class="cover-block">
        <on-ui-cover [cover]="meetingCover"></on-ui-cover>
      </div>
      <div class="text-block">
        <p class="subject">{{meetingSubject}}</p>
        <p class="title">{{meetingTitle}}</p>
        <div class="stats">
          <app-rating [stats]="author?.stats" [user]="author"></app-rating>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="review">
        <h2 class="question">{{ 'meeting-review-form.comment-placeholder' | translate }}</h2>
        <div class="form">
          <div class="rating-wrap">
            <div class="rating-stars">
              <app-icon *ngFor="let rating of [1, 2, 3, 4, 5]; trackBy: trackByFn"
                   class="rating-stars-icon"
                   [class.active]="rating <= meetingReview.rating"
                   width="22" height="22" icon="rating"
                   (click)="setRating(rating)">
              </app-icon>
            </div>
          </div>
          <on-ui-textarea [placeholder]="'meeting-review-form.comment-placeholder' | translate"
                          [(ngModel)]="meetingReview.comment"></on-ui-textarea>
        </div>
      </div>
      <div class="actions">
        <on-ui-button [label]="'meeting-review-form.complain'"
                      (click)="openComplaintModal()"
                      class="transparent">
        </on-ui-button>
        <on-ui-button [label]="'meeting-review-form.post-review'"
                      [state]="submitState"
                      [disabled]="!meetingReview.rating"
                      (click)="submit()"
                      class="primary">
        </on-ui-button>
      </div>
    </div>
  </ng-template>

  <ng-template #showReview>
    <app-meeting-review [meetingReview]="meetingReview"
                        (onEdit)="changeMode()">
    </app-meeting-review>
  </ng-template>
</div>

<app-modal *ngIf="toggleComplaintModal && deviceService.isDesktop()" (closed)="openComplaintModal()">
  <app-modal-body>
    <app-complaint-meeting-form [meeting]="meeting" [author]="author"></app-complaint-meeting-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="toggleComplaintModal && !deviceService.isDesktop()" (closed)="openComplaintModal()">
  <app-mobile-modal-body>
    <app-complaint-meeting-form [meeting]="meeting" [author]="author"></app-complaint-meeting-form>
  </app-mobile-modal-body>
</app-mobile-modal>
